



































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import { UserDto, UserSubmitDto } from '@/api';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import AddressField from '@/views/account/user/AddressField.vue';
import KeycloakService from '@/services/KeycloakService';

@Component({
  components: {AddressField, LoadingIndicator},
})
export default class UserEdit extends Vue {
  public routes = Routes;
  public saving = false;
  public userStore = getModule(UserStore, this.$store);
  public pageSize = this.userStore.currentPageSize;

  private get userPageSize() {
    return this.userStore.currentPageSize;
  }

  private get currentUser(): UserDto | null {
    return this.userStore.currentUser;
  }

  private get currentEditUser(): UserSubmitDto | null {
    return this.userStore.currentEditUser;
  }

  private get keycloakPasswordChangeUrl() {
    return KeycloakService.getChangePasswordUrl(this.userStore.currentLanguage);
  }

  private get hasSpecialSalutation() {
    return !!this.currentEditUser && this.currentEditUser.salutation !== this.$t('message.userData.salutationValue.mrs')
      && this.currentEditUser.salutation !== this.$t('message.userData.salutationValue.mr');
  }

  private async save() {
    if (this.currentEditUser) {
      this.saving = true;
      const response = await this.userStore.updateCurrentUser(this.currentEditUser);
      this.saving = false;
      if (response.success) {
        this.$router.push({name: Routes.Profile});
      }
    }
  }
}
